export const Sections = Object.freeze({
  Conductor: 'Conductor',
  PreSpudPreparation: 'Pre-Spud Preparation',
  Intermediate: 'Intermediate',
  LowerCompletion: 'Lower Completion',
  MiddleCompletion: 'Middle Completion',
  PilotHole: 'Pilot Hole',
  Production: 'Production',
  Reservoir: 'Reservoir',
  RigMove: 'Rig Move',
  Surface: 'Surface',
  UpperCompletion: 'Upper Completion',
  XMT: 'XMT',
  SitePreparation: 'Site Preparation',
  Custom: 'Custom',
});

export const DEFAULT_SECTION_INDEX = 12;
